import { TGetOrderResponse } from '@p2p/services';
import { BANKS } from '@p2p/shared/constants';
import { toUTF8BinaryString } from '@p2p/shared/functions';

export const generateQrInvoiceForSber = (order: TGetOrderResponse) => {
  const phoneNumber = order?.requisite?.phone_number || '';
  const phoneNumberDigits = phoneNumber.replace(/\D/g, '');
  const swiftCode = BANKS[order.requisite.bank.name]?.swift || '';
  const expectedIncome = order.expected_income;
  const receiverName = order.requisite.fio;

  const link = `transfers/abroad?phoneNumber=${phoneNumberDigits}&bank=${swiftCode}&amount=${expectedIncome}&receiverName=${receiverName}`;

  return toUTF8BinaryString(link);
};
